import React from 'react';
import Hero from '../components/Hero';
import Highlights from '../components/Highlights';
import Services from '../components/Services';
import About from '../components/About';
import Gallery from '../components/Gallery';
import Reviews from '../components/Reviews';
import Location from '../components/Location';
import FAQ from '../components/FAQ';
import FinalCTA from '../components/FinalCTA';

const Home = () => {
  return (
    <>
      <Hero />
      <Highlights />
      <Services />
      <About />
      <Gallery />
      <Reviews />
      <Location />
      <FAQ />
      <FinalCTA />
    </>
  );
};

export default Home;
